import Swiper, { Autoplay, Navigation, Grid, Pagination, breakpoints} from 'swiper';

Swiper.use([Autoplay, Navigation, Grid, Pagination, breakpoints ]);

if (window.innerWidth < 821) {
  var swiper = new Swiper(".swiper", {
    slidesPerView: 1,
    centeredSlides: true,
    spaceBetween: 30,
    pagination: {
      el: ".swiper-pagination",
    },

    breakpoints: {
      300: {
        slidesPerView: 1.4,
      },

      375: {
        slidesPerView: 1.5,
      },

      390: {
        slidesPerView: 1.7,
      },

      412: {
        slidesPerView: 1.8,
      },

      500: {
        slidesPerView: 2,
      },

      570: {
        slidesPerView: 2.2,
      },

      630: {
        slidesPerView: 2.5,
      },

      800: {
        slidesPerView: 3.5,
      },
    },
  });
}
